import { useInputFormat, useInputFormatter } from './timeUtils';
import * as React from 'react';

export default function useTimeInput({
  locale,
  value,
  onChange,
  onValidationError,
}: {
  onChange: (d: Date | undefined) => void;
  locale: undefined | string;
  value: Date | undefined;
  onValidationError?: ((error: string | null) => void) | undefined;
}) {
  const [error, setError] = React.useState<null | string>(null);
  const formatter = useInputFormatter({ locale });
  const inputFormat = useInputFormat({ formatter, locale });
  const formattedValue = value ? formatter.format(value) : '';
  const onChangeText = (date: string, maskLengthReached?: boolean) => {
    if (date === '') {
      onChange(undefined);
      return;
    }
    const hoursIndex = inputFormat.indexOf('HH');
    const minutesIndex = inputFormat.indexOf('MM');

    const hours = Number(date.slice(hoursIndex, hoursIndex + 2));
    const minutes = Number(date.slice(minutesIndex, minutesIndex + 2));

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      const inputError = "Le format de l'heure est incorrect";
      setError(inputError);
      onValidationError && onValidationError(inputError);
      return;
    }
    if (!maskLengthReached) {
      return;
    }

    const finalDate = new Date();
    finalDate.setHours(hours);
    finalDate.setMinutes(minutes);
    finalDate.setSeconds(0);

    setError(null);
    onValidationError && onValidationError(null);
    onChange(finalDate);
  };
  return {
    onChange,
    error,
    formattedValue,
    onChangeText,
    inputFormat,
  };
}
